<template>
    <div class="solution">
      <div class="main">
        <div class="bg1">
          <div class="model1">
            <p class="position">您所在的位置：首页 > 智慧安防</p>
            <p class="title">什么是智慧安防</p>
            <p class="title2"></p>
            <div class="model1-main">
              <div class="left">
                <p>5G工程云 是一款基于4G/5G智能硬件+AI视频分析+云平台为一体智能综合管理平台。该产品可为分散式或集中式施工现场，提供安全可靠的视频监管、行为分析、事件预警等功能，帮助监管部门、建设单位、施工单位提升现场管理能力。</p>
                <img class="securityClass scale" :src="url + '/assets/security/security-class.png'"> 
              </div>
              <div class="right">
                <img class="scale" :src="url + '/assets/security/security-examples.png'">
              </div>
            </div>
          </div>
        </div>
        <div class="bg2">
          <div class="model2">
            <div class="model1-main">
              <div class="left">
                <p class="title">云视频终端</p>
                <div class="title2"></div>
                <div class="p1 mt54"><img :src="url + '/assets/security/arrow.png'"><span>便捷式手提箱设计，随身携带，快速部署；</span></div>
                <div class="p1"><img :src="url + '/assets/security/arrow.png'"><span>多产品版本，基于 4G/5G 网络的图像传输，稳定清晰，适应不同应用场景；</span></div>
                <div class="p1"><img :src="url + '/assets/security/arrow.png'"><span>双向语音对讲，可实现 “ 对讲机 ” 互联；</span></div>
                <div class="p1"><img :src="url + '/assets/security/arrow.png'"><span>GPS 定位，可视化数据平台，可二次开发；</span></div>
                <div class="p1"><img :src="url + '/assets/security/arrow.png'"><span>大容量移动电源，提升终端使用持久性；</span></div>
              </div>
              <div class="right">
               <img class="edition scale" :src="url + '/assets/security/tour-edition.png'">
                <img class="flagship scale" :src="url + '/assets/security/flagship.png'">
              </div>
            </div>
          </div>
         </div>
          <div class="bg1">
            <div class="model5">
              <p class="title">终端多样性</p>
              <div class="title2"></div>
              <div class="model1-main">
                  <div class="terminalList">
                    <p class="title">感知版</p>
                    <p class="p1">快速磁吸式安装，自带电池无需配电；</p>
                    <p class="p1">可挂载衔接到支架，即挂即用，移动方便；</p>
                    <img class="perception " :src="url + '/assets/security/diversity-perception.png'">
                  </div>
                 <div class="terminalList">
                    <p class="title">瞭望版</p>
                    <p class="p1">磁吸式车辆顶或铁盘，无需配电；</p>
                    <p class="p1">可挂载衔接到支架，即挂即用，移动方便；</p>
                    <img class="perception " :src="url + '/assets/security/diversity-lookout.png'">
                  </div>
                  <div class="terminalList">
                    <p class="title">巡视版</p>
                    <p class="p1">可挂载衔接到支架，即挂即用，移动方便</p>
                    <p class="p1"  style="opacity:0">磁吸式车辆顶或铁盘，无需配电；</p>
                  
                    <img class="perception " :src="url +'/assets/security/diversity-tour-edition.png'">
                  </div>
                  <div class="terminalList">
                    <p class="title">旗舰版</p>
                    <p class="p1">集瞭望版+巡视版优点于一体</p>
                    <p class="p1" style="opacity:0">可挂载衔接到支架，即挂即用，移动方便</p>
                    <img class="perception " :src="url+ '/assets/security/diversity-flagship.png'">
                  </div>
              </div>
            </div>
         </div>
         <div class="bg2">
          <div class="model6">
            <p class="title">智能AI算法</p>
            <div class="title2"></div>
            <div class="aiTitle">以先进的智能AI识别算法代替传统的人工查看，由软件对安全隐患快速识别，快速报警，并可将报警信息推送至相人员手机之中，以“防”代“治”。</div>
            <div class="model1-main">
              <div class="aiList">
                <img :src="url + '/assets/security/anquanmao.png'">
                <p>前端智能感知设备采集生产现场视频，识别人员是否佩戴安全帽，是否在绿色通道行走,是否在危险区域,进而发出警示和提醒，规范从业人员的作业行为。</p>
              </div>
              <div class="aiList">
                  <img :src="url + '/assets/security/stranger.png'">
                <p>需事先定义白名单人脸库，发现不在白名单中的陌生人则告警提醒（检测不到人脸的人员亦视作陌生人），如果是白名单人员则放行。</p>
              </div>
              <div class="aiList">
                  <img :src="url +'/assets/security/fireworks-warning.png'">
                <p>前端智能感知设备实时将上传视频流至系统服务器后系统进行分析若发现有烟雾或火焰进行抓拍、保存，并根据需要进行报警和提示。</p>
              </div>
            </div>
          </div>
         </div>
          <div class="bg1">
            <div class="model7">
              <p class="title">指挥调度平台</p>
              <div class="title2"></div>
              <div class="p1"><img :src="url + '/assets/security/arrow.png'"><span>移动性音视频同步性，在指挥中心即可以清晰看到现场画面，实现了在指挥中心就可以进行远程多方调度，实现最快的命令传达，最优的部署安排，最快捷的前后方信息反馈。</span></div>
              <div class="p1"><img :src="url + '/assets/security/arrow.png'"><span>建立与安全防控体系相配套的新型工地宝系统，实现实施部署的在线化。利用无线技术进行视频、图文信息上报等手段进行“点对点”直接指挥，实现指挥调度的扁平化。</span></div>
              <div class="model1-main">
                  <img class="zong " :src="url+ '/assets/security/zong.png'">
                  <img class="platform " :src="url + '/assets/security/command-platform.png'">
              </div>
            </div>
         </div>

          <div class="bg2">
            <div class="model8">
              <p class="title">数据可视化平台</p>
              <div class="title2"></div>
              <div class="p1"><img :src="url + '/assets/security/arrow.png'"><span>以图表的形式进行可视化展现，真实反应报警信息在不同时间段的变化情况；</span></div>
              <div class="p1"><img :src="url + '/assets/security/arrow.png'"><span>可做为对各班组工作情况的考核之用；</span></div>
              <div class="p1"><img :src="url + '/assets/security/arrow.png'"><span>在线项目地图总览，项目进度跟踪；路径轨迹实时定位。</span></div>
              <div class="model1-main">
                   <el-carousel :interval="4000" type="card" :autoplay="false" >
                    <el-carousel-item v-for="item in arr" :key="item">
                      <img class="medium" :src="item">
                    </el-carousel-item>
                  </el-carousel>
              </div>
            </div>
         </div>

        <div class="bg1">
            <div class="model9">
              <p class="title">其他功能</p>
              <div class="title2"></div>
              <div class="model1-main">
                  <div class="otherList">
                      <img :src="url +  '/assets/security/icon-monitor.png'">
                      <p class="p1">监控中心</p>
                      <p class="p2"></p>
                      <p class="p3">实时播放、画面分割、视频回放、设备控制等</p>
                  </div>
                   <div class="otherList">
                      <img :src="url + '/assets/security/icon-organization.png'">
                      <p class="p1">组织管理</p>
                      <p class="p2"></p>
                      <p class="p3">组织架构、新增、修改、删除等</p>
                  </div>
                   <div class="otherList">
                      <img :src="url + '/assets/security/icon-equipment.png'">
                      <p class="p1">设备管理</p>
                      <p class="p2"></p>
                      <p class="p3">设备统计、设备交互、设备增删改查、时长统计等</p>
                  </div>
                  <div class="otherList">
                      <img :src="url + '/assets/security/icon-system.png'">
                      <p class="p1">系统管理</p>
                      <p class="p2"></p>
                      <p class="p3">用户权限、告警设置等</p>
                  </div>
                  <div class="otherList">
                      <img :src="url + '/assets/security/icon-extend.png'">
                      <p class="p1">扩展其他</p>
                      <p class="p2"></p>
                      <p class="p3">后期针对场景可扩展其他功能需求</p>
                  </div>
              </div>
            </div>
         </div>

          <div class="bg2">
            <div class="model10">
              <p class="title">亮点优势</p>
              <div class="title2"></div>
              <div class="model1-main">
                  <div class="HighlightsList">
                      <img :src="url + '/assets/security/icon-inspection.png'">
                      <p class="p1">自主巡检，智能行为识别与分析</p>
                      <p class="p2">降低现场巡查频次，节约人力成本；便捷的后台人员指挥，现场人员调度。发生工人未佩戴安全帽、陌生人闯入、抽烟、物料违规摆放等违规情况时，系统会自动判断违规行为，自动生成告警信息并推送给相关监管部门负责人。</p>
                  </div>
                  <div class="HighlightsList">
                      <img :src="url + '/assets/security/icon-interconnection.png'">
                      <p class="p1">互联互通、能力中台</p>
                      <p class="p2">打通项目监管、派单流程、施工管理等系统之间的数据孤岛；形成横向到边、纵向到底的数据交互关系，避免信息孤岛和数据死角出现。</p>
                  </div>
                  <div class="HighlightsList">
                      <img :src="url + '/assets/security/icon-visualization.png'">
                      <p class="p1">一面屏可视、一幅图管理、一张网联动</p>
                      <p class="p2">系统针对异常情况发生时，数据智能分析将对其进行智能判断和预测，迅速反应处理；甚至做到提前预防、主动应对，为决策管理部门提供决策依据。</p>
                  </div>
              </div>
            </div>
         </div>

         <div class="bg1">
            <div class="model11">
              <p class="title">与传统对比</p>
              <div class="title2"></div>
              <div class="p2">整个系统部署简单、随启随用，不受地域环境气候限制。并且系统能够实现预警智能化，事情可视化、视频信息结构化、指挥无遗漏，调度无延时，非常贴近实际作用场景。</div>
              <div class="p1"><img :src="url + '/assets/security/arrow.png'"><span>传统的施工过程无监管，通过便携式布控球把施工过程搬到了线上实时监管。</span></div>
              <div class="p1"><img :src="url + '/assets/security/arrow.png'"><span>能有效提升行业监管和服务能力：通过“中国电信工地宝系统”的使用，能规避安全隐患发生，保障工程质量，实现质量溯源和劳务实名制管理，促进大数据的建立，有效支撑行业主管部门对工程现场的安全、人员的监管和服务。</span></div>
              <div class="p1"><img :src="url + '/assets/security/arrow.png'"><span>为政府监管部门、企业、项目各级承包商提供对进度、安全质量、劳务安全等方面关键信息的即时感知能力、及时决策能力和有效干预能力。</span></div>
              <div class="model1-main">
                 <div class="list">
                      <img :src="url + '/assets/security/one.png'">
                      <p class="listp2">前端产品兼容</p>
                      <div class="listp1"><span class="span1">A、</span><span  class="span2">支持海康、大华、宇视、科达、华为、TP_LINK等平台 SDK级接入；</span></div>
                      <div class="listp1"><span class="span1">B、</span><span  class="span2">ONVIF、GB/T 28181、SVAIC、 RTSP、FTP、SMTP、UPnP/SNMP等；</span></div>
                 </div>
                 <div class="list">
                      <img :src="url +  '/assets/security/two.png'">
                      <p class="listp2 listpspan">
                        <span>平安城市级</span>
                        <span>视频平台软件互联互通</span>
                      </p>
                      <div class="listp1"><span class="span1">A、</span><span  class="span2">支 持 使 用 S D K 、 私 有 协 议 、 国 标 GB/T28181、Onvif、RTSP等方式实现接入</span></div>
                      <div class="listp1"><span class="span1">B、</span><span  class="span2">满足快速定制开发接入需求</span></div>
                 </div>
                 <div class="list">
                      <img :src="url + '/assets/security/three.png'">
                      <p class="listp2">平台软件完备的 SDK 应用</p>
                      <div class="listp1"><span class="span1">A、</span><span  class="span2">为第三方应用平台提供SDK支持；</span></div>
                      <div class="listp1"><span class="span1">B、</span><span  class="span2">为行业应用软件提供中间件接口；</span></div>
                 </div>
              </div>
            </div>
         </div>

         <div class="bg2">
            <div class="model12">
              <p class="title">涵盖多个应用场景</p>
              <div class="title2"></div>
              <div class="model1-main">
                 <div class="list">
                    <img :src="url + '/assets/security/scene-site.png'">
                    <p class="p1">智慧工地</p>
                    <p class="p2"></p>
                    <div class="div">
                        <p class="p3">建筑相关单位：</p>
                        <div class="listp1"><span class="span1">• </span><span  class="span2">工程监理公司（施工规范、质量的把控）</span></div>
                        <div class="listp1"><span class="span1">• </span><span  class="span2">项目施工单位（施工安全、进度的把控、库房物料监管）</span></div>
                        <div class="listp1"><span class="span1">• </span><span  class="span2">装修施工单位，在线监督</span></div>
                    </div>
                 </div>
                 <div class="list">
                    <img :src="url + '/assets/security/scene-rescue.png'">
                    <p class="p1">应急救援</p>
                    <p class="p2"></p>
                    <div class="div">
                        <p class="p3"> 应急管理办：</p>
                        <div class="listp1"><span class="span1">• </span><span  class="span2">应急处突：突发性自然灾害、群体性社会事件</span></div>
                        <div class="listp1"><span class="span1">• </span><span  class="span2">远程资源调度指挥，信息互动</span></div>
                    </div>
                 </div>
                 <div class="list">
                    <img :src="url + '/assets/security/scene-police.png'">
                    <p class="p1">公安布控</p>
                    <p class="p2"></p>
                    <div class="div">
                        <p class="p3"> 公安系统：</p>
                        <div class="listp1"><span class="span1">• </span><span  class="span2">人员密集区域移动布控；</span></div>
                        <div class="listp1"><span class="span1">• </span><span  class="span2">侦查办案：专业警种隐秘侦查办案、连续作案嫌疑人侦控、恶性疑难案件侦破</span></div>
                        <div class="listp1"><span class="span1">• </span><span  class="span2">安保活动：重大会议、论坛、演唱会等娱乐活动、马拉松等体育赛事；</span></div>
                    </div>
                 </div>
                 <div class="list">
                    <img :src="url + '/assets/security/scene-line-repair.png'">
                    <p class="p1">线路抢修</p>
                    <p class="p2"></p>
                    <div class="div">
                        <p class="p3">电力、水利、通讯施工抢修：</p>
                        <div class="listp1"><span class="span1">• </span><span  class="span2">与前方人员对讲，转动球机巡视四方，实现真正的远程监测</span></div>
                    </div>
                 </div>
              </div>
            </div>
         </div>

      </div>
       <foot></foot>
    </div>
</template>
<script>
import defaultSettings from '@/defaultSettings'
import foot from '../components/foot'
const img1 =  defaultSettings.url + '/assets/security/visualization-platform1.png';
const img2 =  defaultSettings.url + '/assets/security/visualization-platform2.png';
const img3 =  defaultSettings.url + '/assets/security/visualization-platform3.png';
export default {
  data() {
    return {
      url: defaultSettings.url,
      arr: [img1, img2, img3]
    }
  },
  components: {
    foot
  },
  mounted() {
    window.scrollTo({ left: 0, top: 0 })
  },
  methods: {
    
  }
}
</script>
<style lang="less" scoped>

.bg1{
  background: #F9F9F9;
}
.bg2{
  background: #fff;
}
.title{
  color:#333;
  font-size:34px;
  text-align: left;
}
.title2:after {
  display: block;
  content: "";
  height: 0;
  line-height: 0;
  visibility: hidden;
  clear: both;
}
.title2 {
  zoom: 1; /* 为了兼容IE */
}
.title2{
  width: 87px;
  height: 3px;
  background: #167EFB;
  text-align: left;
  margin:30px 0 25px;
  display: block;
}
// 缩放
.scale{
    width:100%;
    transition: all 0.6s;
}
.scale:hover{
    transition: all 0.6s;
    transform: scale(1.08);
}

.solution{
  padding-top:140px;
  background: #F9F9F9;
  .main{
    .model1{
      margin-top:84px;
      width:1200px;
      margin: 0 auto;
      .position{
        margin-top:25px;
        color:#999999;
        font-size:14px;
        margin-bottom:50px;
      }
      .title{
        color:#333;
        font-size:34px;
        text-align: center;
      }
      .title2{
        width: 87px;
        height: 3px;
        background: #167EFB;
        text-align: center;
        margin:30px auto 0;
      }
      .model1-main{
        padding-bottom:95px;
        display: flex;
         margin-top:60px;
        .left{
          width:450px;
          // height:500px;
          p{
            font-size:14px;
            color:#333;
            margin-bottom:30px;
            line-height: 30px;
          }
          .securityClass{
            width:450px;
            height:277px;
          }
          // @media screen and (max-width: 1500px) {
          //     p {
          //        line-height: 25px;
          //     }
          // }
        }
        .right{
          width:697px;
          height:500px;
          margin-left:50px;
          img{
            width:697px;
            height:473px;
          }
        }
      }
    }
    .model2{
      width:1200px;
      margin: 0px auto;
      padding-top:80px;
      .model1-main{
        padding-bottom:95px;
        display: flex;
        .left{
          width:350px;
          .mt54{
            margin-top:54px;
          }
          .p1{
            margin-bottom:15px;
            line-height: 30px;
            img {
              width:23px;
              height:11px;
              vertical-align: middle;
              margin-right:18px;
            }
            span{
              font-size:14px;
              color:#333;
              width:266px;
              display: inline-block;
              vertical-align: top;
            }
          }
        }
        .right{
          width:800px;
          height:594px;
          margin-left:70px;
          margin-top:10px;
          display:flex;
          .edition{
            width:445px;
            height:473px;
          }
          .flagship{
             width:294px;
            height:579px;
            margin-left:78px;
          }
        }
      }
    }
    .model5{
      width:1200px;
      margin: 0px auto;
      padding-top:90px;
      .model1-main{
        padding-bottom:95px;
        display: flex;
        margin-top:50px;
        .terminalList{
          width:288px;
          // height:500px;
          background: #FFFFFF;
          border-radius: 4px;
          margin-right:16px;
          text-align:center;
          padding:30px 0 24px 0;
           transition: all 0.6s;
          .title{
            font-size: 22px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 32px;
            text-align:center;
            margin-bottom:20px;
          }
          .p1{
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666;
            line-height: 32px;
          }
          .perception{
            width:243px;
            height:366px;
            margin-top:16px;
             padding:0 22px;
          }
        }
        .terminalList:hover{
          background: #fff;
           transition: all 0.6s;
          transform: translate(0,-8px);
        }
      }
    }
     .model6{
      width:1200px;
      margin: 0px auto;
      padding-top:90px;
      .aiTitle{
          width: 728px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 26px;
          margin:20px 0 50px 0;
        }
      .model1-main{
        padding-bottom:95px;
        display: flex;
        
        .aiList{
          width:380px;
          margin-right:30px;
          img{
             width:380px;
             height:344px;
          }
          p{
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 30px;
            margin-top:30px;
            text-align:center;
          }
        }
        .aiList:nth-child(3n){
           margin-right:0px;
        }
      }
    }
    .model7{
      width:1200px;
      margin: 0px auto;
      padding-top:90px;
      .p1{
        margin-bottom:15px;
        line-height: 30px;
        img {
          width:23px;
          height:11px;
          vertical-align: middle;
          margin-right:18px;
        }
        span{
          font-size:14px;
          color:#333;
          width:1080px;
          display: inline-block;
          vertical-align: top;
        }
      }
      .model1-main{
        padding-bottom:95px;
        // display: flex;
        margin-top:50px;
        .zong{
          width:1200px;
          height:235px;
        }
        .platform{
          width:1200px;
          height:546px;
          margin-top:35px;
        }
      }
    }

    .model8{
      width:1200px;
      margin: 0px auto;
      padding-top:90px;
      .p1{
        margin-bottom:15px;
        line-height: 30px;
        img {
          width:23px;
          height:11px;
          vertical-align: middle;
          margin-right:18px;
        }
        span{
          font-size:14px;
          color:#333;
          width:1080px;
          display: inline-block;
          vertical-align: top;
        }
      }
      .model1-main{
        padding-bottom:95px;
        // display: flex;
        margin-top:50px;

        img{
          // width:977px;
          width:100%;
          height:450px;
        }
      }
    }

     .model9{
      width:1200px;
      margin: 0px auto;
      padding-top:90px;
      .p1{
        margin-bottom:15px;
        line-height: 30px;
        img {
          width:23px;
          height:11px;
          vertical-align: middle;
          margin-right:18px;
        }
        span{
          font-size:14px;
          color:#333;
          width:1080px;
          display: inline-block;
          vertical-align: top;
        }
      }
      .model1-main{
        padding-bottom:95px;
        display: flex;
        margin-top:50px;
        .otherList{
          width: 240px;
          height: 299px;
          background: #FFFFFF;
          border-radius: 4px;
          text-align:center;
          margin-right:10px;
           transition: all 0.6s;
          img{
            width:75px;
            height:75px;
            margin:30px 0 25px 0;
          }
          .p1{
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 32px;
            margin-bottom:20px;
          }
          .p2{
            width: 20px;
            height: 3px;
            background: #167EFB;
            margin:0 auto;
          }
          .p3{
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            width: 169px;
            line-height: 30px;
             margin:20px auto 0;
          }
        }
        .otherList:nth-child(5n){
           margin-right:0px;
        }
        .otherList:hover{
          background: #fff;
           transition: all 0.6s;
          transform: translate(0,-8px);
        }
      }
    }

    .model10{
      width:1200px;
      margin: 0px auto;
      padding-top:90px;
      .model1-main{
        padding-bottom:95px;
        display: flex;
        margin-top:50px;
        .HighlightsList{
          transition: all 0.6s;
          width: 380px;
          height: 402px;
          background: #FFFFFF;
          border: 1px solid #E3E3E3;
          text-align:center;
          margin-right:30px;
          img{
            width:154px;
            height:115px;
            margin:30px 0 20px 0;
          }
          .p1{
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 24px;
              // width: 339px;
              // margin:0 auto;
          }
           .p2{
            font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 30px;
              width: 332px;
              margin:30px auto 0;
          }
        }
        .HighlightsList:hover{
          background: #fff;
           transition: all 0.6s;
          transform: translate(0,-8px);
        }
         .HighlightsList:nth-child(3n){
           margin-right:0px;
        }
      }
    }

    .model11{
      width:1200px;
      margin: 0px auto;
      padding-top:90px;
      .p2{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 32px;
        margin-bottom:30px;
      }
      .p1{
        margin-bottom:15px;
        line-height: 30px;
        img {
          width:23px;
          height:11px;
          vertical-align: middle;
          margin-right:18px;
        }
        span{
          font-size:14px;
          color:#666;
          width:1100px;
          display: inline-block;
          vertical-align: top;
        }
      }
      .model1-main{
        padding-bottom:95px;
        display: flex;
        margin-top:50px;
        .list{
          width: 360px;
          height: 382px;
          background: #FFFFFF;
          border-radius: 10px;
          text-align:center;
          margin-right:60px;
          img{
              width: 51px;
              height: 42px;
              margin:40px 0 25px 0;
          }
          .listp2{
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            height:50px;
            line-height:50px;
            transition: all 0.6s;
             margin-bottom:20px;
            span{
              display:block;
            }
          }
          .listpspan{
            line-height:25px;
          }
          .listp1{
            margin-bottom:10px;
            line-height: 30px;
            .span1 {
              vertical-align: middle;
              margin-right:18px;
              font-size: 14px;
              color:#333;
            }
            .span2{
              font-size:14px;
              color:#333;
              width:250px;
              text-align:left;
              display: inline-block;
              vertical-align: top;
            }
          }
        }
         .list:hover{
           background: #fff;
           transition: all 0.6s;
           transform: translate(0,-8px);
        }
         .list:nth-child(3n){
          margin-right:0px;
        }
      }
    }

    .model12{
      width:1200px;
      margin: 0px auto;
      padding-top:90px;
      .model1-main{
        padding-bottom:95px;
        display: flex;
        margin-top:50px;
         .list{
          text-align:center;
          margin-right:10px;
          width: 290px;
          // height: 507px;
          padding-bottom:10px;
          background: #FFFFFF;
          border: 1px solid #E3E3E3;
          img{
              width: 290px;
              height: 200px;
              margin:0px 0 30px 0;
          }
          .p1{
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            transition: all 0.6s;
            margin-bottom:20px;
            line-height: 24px
          }
          .p2{
            width: 20px;
            height: 3px;
            background: #167EFB;
            margin:0 auto 30px;
          }
          .div{
            text-align:left;
            //  width:275px;
            padding-left:10px;
             margin:0 auto;
            .p3{
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 30px;
            }
            .listp1{
              margin-bottom:0px;
              line-height: 30px;
              .span1 {
                vertical-align: middle;
                font-size: 14px;
                color:#666;
              }
              .span2{
                font-size:14px;
                color:#666;
                width:260px;
                text-align:left;
                display: inline-block;
                vertical-align: top;
              }
            }
          }
          
        }
         .list:hover{
           background: #fff;
           transition: all 0.6s;
           transform: translate(0,-8px);
        }
         .list:nth-child(4n){
          margin-right:0px;
        }
      }
    }

  }
}
</style>


// WEBPACK FOOTER //
// src/view/security.vue